
export const URL_API = process.env.REACT_APP_API_URL//"http://localhost/api/"

export const URL_API_IMAGES = `${process.env.REACT_APP_API_URL}/images/`// "https://cms.barrilito.com.mx/back/images/" //"http://localhost/api/images/"
